<template>
	<div class="left main main_white col-lg-10 col-md-10 col-xs-12">
		<modal name="order-copy" @before-open="beforePop">
			<order-copy :order="copyOrder"></order-copy>
		</modal>

		<h1 class="cat_title">היסטוריית הזמנות</h1>
		<div class="title_symbol">
			<TIME />
		</div>

		<div class="loader dots" v-if="!loaded">כמה שניות.. אנחנו מעלים את כל ההזמנות שלך</div>

		<template v-else>
			<div class="row empty-fav empty-orders" v-if="!orders">
				<div class="empty-nice-img">
					<EMPTYORDER />
				</div>
				<h2
					class="title"
					v-if="
						wpData.globalOptions.order_history_no_orders &&
						wpData.globalOptions.order_history_no_orders.title
					"
				>
					{{ wpData.globalOptions.order_history_no_orders.title }}
				</h2>
				<div
					class="text"
					v-if="
						wpData.globalOptions.order_history_no_orders &&
						wpData.globalOptions.order_history_no_orders.text
					"
					v-html="wpData.globalOptions.order_history_no_orders.text"
				></div>
				<div class="bt_green">
					<router-link to="/">התחלת קנייה</router-link>
				</div>
			</div>

			<div class="all_orders clearfix" v-else>
				<h2
					class="text subtitle bold"
					v-if="
						wpData.globalOptions.order_history_has_orders &&
						wpData.globalOptions.order_history_has_orders.title
					"
				>
					{{ wpData.globalOptions.order_history_has_orders.title }}
				</h2>
				<div
					v-if="
						wpData.globalOptions.order_history_has_orders &&
						wpData.globalOptions.order_history_has_orders.text
					"
					v-html="wpData.globalOptions.order_history_has_orders.text"
				></div>

				<div id="no-orders-to-edit" v-if="!hasEditableOrders">אין לך הזמנות זמינות לעריכה</div>

				<div class="order-rows">
          <order-row v-bind:order="order" v-for="(order, index) in orders" :key="index" />
        </div>

				<div class="show_more_orders" v-if="orders.length < all_orders.length" ref="loadmore">
					<a href="javascript:void(0);" @click="showMore">+ טעינת עגלות קודמות</a>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
	import TIME from "../../assets/img/time.svg";
	import EMPTYORDER from "../../assets/img/empty-orders.svg";
	import OrderCopy from "../Popups/OrderCopy";
	import { mapActions } from "vuex";
	import OrderRow from "./Components/OrderRow";

	export default {
		data() {
			return {
				all_orders: this.$store.state.userLoggedInfo.orders /* wpData.pageData,*/,
				// all_orders: [], // wpData.user.orders, /* wpData.pageData,*/
				loaded: false,
				loaderGif: wpData.assets_url + "/layout/loader.gif",
				copyOrder: "",
				numberOfOrders: 5,
				wpData: wpData,
			};
		},
		beforeCreate() {
			this.loaded = false;
			// this.$ajax.get(ajaxUrl + "?action=getOrders").then(response => {
			//   this.loaded = true;
			//   if (response.data) {
			//     this.all_orders = response.data;
			//
			//     // todo: finish auto show more on scroll
			//     // window.addEventListener('scroll', () => {
			//     //   const scrollTop = window.innerHeight;
			//     //   console.log(this.$refs.loadmore.offsetTop)
			//     //   if (this.$refs.loadmore) {
			//     //     if (scrollTop <= this.$refs.loadmore.offsetTop) {
			//     //       console.log('Item has reached the top');
			//     //     }
			//     //   }
			//     // });
			//   }
			// }).catch(e => console.log(e));
		},
		mounted() {
			if (!this.all_orders) {
				this.$ajax
					.get(ajaxUrl + "?action=getOrders")
					.then((response) => {
						if (response.data) {
							this.loaded = true;
							this.all_orders = response.data;

							// todo: finish auto show more on scroll
							// window.addEventListener('scroll', () => {
							//   const scrollTop = window.innerHeight;
							//   console.log(this.$refs.loadmore.offsetTop)
							//   if (this.$refs.loadmore) {
							//     if (scrollTop <= this.$refs.loadmore.offsetTop) {
							//       console.log('Item has reached the top');
							//     }
							//   }
							// });
						}
					})
					.catch((e) => console.log(e));
			} else {
				this.loaded = true;
			}
		},
		computed: {
			// all_orders(){
			//   return wpData.pageData;
			// },
			orders() {
				if (this.all_orders) {
					let orders = this.all_orders;
					if (orders.length > 0) {
						return orders.slice(0, this.numberOfOrders);
					}
				}
				return null;
			},
			hasEditableOrders() {
				// Returns boolean wether or not there are orders available for edit
				return this.all_orders ? this.all_orders.some((order) => order.is_edit === 1) : false;
			},
		},
		methods: {
			...mapActions["getProductById"],
			beforePop(event) {
				this.copyOrder = event.params.order;
			},
			showMore() {
				this.numberOfOrders += 5;
			},
		},
		components: {
			TIME,
			EMPTYORDER,
			OrderRow,
			OrderCopy,
		},
	};
</script>

<style scoped lang="scss">
	#no-orders-to-edit {
		color: #ea4726;
		font-weight: bold;
		padding: 1rem 0 2rem 0;
	}
  .order-rows {
    background: #fff;
    margin: 0 -18px;
    ::v-deep .order_row {
      margin: 0;
    }
  }

</style>
